import { Loader2 } from 'lucide-react'
import { ProgressBar } from './ProgressBar'

interface ProgressDialogProps {
  title: string
  current: number
  total: number
  status?: string
  hint?: string
  onCancel?: () => void
  cancelLabel?: string
  tone?: 'default' | 'danger'
}

export function ProgressDialog({
  title,
  current,
  total,
  status,
  hint,
  onCancel,
  cancelLabel = 'Abbrechen',
  tone = 'default',
}: ProgressDialogProps) {
  const statusText =
    status ?? (total > 0 ? `${current} von ${total} verarbeitet` : 'Bitte warten…')
  const percent = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : null
  const spinnerColor = tone === 'danger' ? 'text-red-500' : 'text-blue-600'

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="progress-dialog-title"
        className="bg-white rounded-lg p-6 shadow-xl max-w-sm w-full mx-4"
      >
        <div className="flex items-center gap-3 mb-3">
          <Loader2 className={`w-5 h-5 animate-spin ${spinnerColor}`} />
          <span id="progress-dialog-title" className="font-medium text-gray-900">
            {title}
          </span>
        </div>
        <div className="text-sm text-gray-600 mb-2">{statusText}</div>
        {percent !== null && (
          <div className="mb-2 text-right text-sm font-medium text-gray-800">{percent}%</div>
        )}
        <ProgressBar current={current} total={total} label={title} tone={tone} className="h-3" />
        {hint && <p className="text-xs text-gray-500 mt-3">{hint}</p>}
        {onCancel && (
          <button
            onClick={onCancel}
            className="mt-4 w-full px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-md text-sm font-medium transition-colors"
          >
            {cancelLabel}
          </button>
        )}
      </div>
    </div>
  )
}
